import { createFileRoute } from '@tanstack/react-router';
import { Card, List, Stack, Text, Title } from '@mantine/core';

function DataDeletion() {
  return (
    <Stack gap="md">
      <Title order={2}>Data Deletion</Title>
      <Text>You can request deletion of your data in two ways:</Text>
      <Card>
        <Stack gap="sm">
          <Text fw={600}>Through Meta</Text>
          <Text>
            From your Facebook account settings, navigate to <em>Settings → Apps and Websites</em>,
            select LeadSync, and choose <em>Send a request to delete data</em>. Meta will deliver a
            signed deletion request to our servers; we process it within 24 hours and reply with a
            confirmation URL you can visit to verify the deletion.
          </Text>
        </Stack>
      </Card>
      <Card>
        <Stack gap="sm">
          <Text fw={600}>Directly</Text>
          <Text>
            Email <a href="mailto:privacy@leadsync.com">privacy@leadsync.com</a> from the address
            associated with your account. We will respond with a confirmation code and verification
            URL within two business days.
          </Text>
        </Stack>
      </Card>
      <Text fw={600}>What gets deleted</Text>
      <List size="sm">
        <List.Item>Your User row + every Session for your account</List.Item>
        <List.Item>Every encrypted Meta access token attached to your account</List.Item>
        <List.Item>Every login log entry attached to your account</List.Item>
      </List>
      <Text c="dimmed" size="sm">
        Vendor-wide data (your business's WhatsApp messages, contacts, campaigns) is removed via a
        separate vendor-side deletion flow available to your business administrator. This page
        addresses individual user data only — the data Meta requires us to delete on your behalf.
      </Text>
    </Stack>
  );
}

export const Route = createFileRoute('/legal/data-deletion')({ component: DataDeletion });
